var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart-top"},[_vm._m(0),(_vm.cartItemCount >= 1)?_c('div',{staticClass:"cart-items"},[_c('span',[_vm._v(_vm._s(_vm.cartItemCount)+" ITEM"+_vm._s(_vm.cartItemCount > 1 ? "S" : ""))])]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-header"},[_c('h6',{staticClass:"modal-title"},[_vm._v("Shopping Cart")])])
}]

export { render, staticRenderFns }